import { SortJobBy, SortJobOptions } from '../entities/job/job.sort.options';
import { ClientOperationFilter } from '../portal/client.operation.request';
import { ContractorOperationFilter } from '../portal/contractor.operation.request';

export class KanbanUtility {

    public static buildSortOption(sort: SortJobOptions) {

        const { sortBy, sortType } = sort;

        if (sortBy === SortJobBy.CreatedDate && sortType === 'DESC') {
            return [
                {
                    label: 'Sort By',
                    items: [
                        { label: 'Created Date (Newest to Oldest)', value: { sortBy: SortJobBy.CreatedDate, sortType: 'DESC' } },
                        { label: 'Completed Date (Closest to Farthest)', value: { sortBy: SortJobBy.CompletedDate, sortType: 'ASC' } },
                        { label: 'Due Date (Closest to Farthest)', value: { sortBy: SortJobBy.DueDate, sortType: 'ASC' } },
                        { label: 'Priority (High to Low)', value: { sortBy: SortJobBy.SystemPriority, sortType: 'ASC' } }
                    ]
                },
                {
                    label: 'Sort Order',
                    items: [
                        { label: 'Oldest to Newest', value: { sortBy: SortJobBy.CreatedDate, sortType: 'ASC' } }
                    ]
                }
            ];
        } else if (sortBy === SortJobBy.CreatedDate && sortType === 'ASC') {
            return [
                {
                    label: 'Sort By',
                    items: [
                        { label: 'Created Date (Oldest to Newest)', value: { sortBy: SortJobBy.CreatedDate, sortType: 'ASC' } },
                        { label: 'Completed Date (Closest to Farthest)', value: { sortBy: SortJobBy.CompletedDate, sortType: 'ASC' } },
                        { label: 'Due Date (Closest to Farthest)', value: { sortBy: SortJobBy.DueDate, sortType: 'ASC' } },
                        { label: 'Priority (High to Low)', value: { sortBy: SortJobBy.SystemPriority, sortType: 'ASC' } }
                    ]
                },
                {
                    label: 'Sort Order',
                    items: [
                        { label: 'Newest to Oldest', value: { sortBy: SortJobBy.CreatedDate, sortType: 'DESC' } }
                    ]
                }
            ];
        } else if (sortBy === SortJobBy.DueDate && sortType === 'ASC') {
            return [
                {
                    label: 'Sort By',
                    items: [
                        { label: 'Created Date (Newest to Oldest)', value: { sortBy: SortJobBy.CreatedDate, sortType: 'DESC' } },
                        { label: 'Completed Date (Closest to Farthest)', value: { sortBy: SortJobBy.CompletedDate, sortType: 'ASC' } },
                        { label: 'Due Date (Closest to Farthest)', value: { sortBy: SortJobBy.DueDate, sortType: 'ASC' } },
                        { label: 'Priority (High to Low)', value: { sortBy: SortJobBy.SystemPriority, sortType: 'ASC' } }
                    ]
                },
                {
                    label: 'Sort Order',
                    items: [
                        { label: 'Farthest to Closest', value: { sortBy: SortJobBy.DueDate, sortType: 'DESC' } }
                    ]
                }
            ];
        } else if (sortBy === SortJobBy.DueDate && sortType === 'DESC') {
            return [
                {
                    label: 'Sort By',
                    items: [
                        { label: 'Created Date (Newest to Oldest)', value: { sortBy: SortJobBy.CreatedDate, sortType: 'ASC' } },
                        { label: 'Completed Date (Closest to Farthest)', value: { sortBy: SortJobBy.CompletedDate, sortType: 'ASC' } },
                        { label: 'Due Date (Farthest to Closest)', value: { sortBy: SortJobBy.DueDate, sortType: 'DESC' } },
                        { label: 'Priority (High to Low)', value: { sortBy: SortJobBy.SystemPriority, sortType: 'ASC' } }
                    ]
                },
                {
                    label: 'Sort Order',
                    items: [
                        { label: 'Closest to Farthest', value: { sortBy: SortJobBy.DueDate, sortType: 'ASC' } }
                    ]
                }
            ];
        } else if (sortBy === SortJobBy.CompletedDate && sortType === 'ASC') {
            return [
                {
                    label: 'Sort By',
                    items: [
                        { label: 'Created Date (Newest to Oldest)', value: { sortBy: SortJobBy.CreatedDate, sortType: 'ASC' } },
                        { label: 'Completed Date (Closest to Farthest)', value: { sortBy: SortJobBy.CompletedDate, sortType: 'ASC' } },
                        { label: 'Due Date (Closest to Farthest)', value: { sortBy: SortJobBy.DueDate, sortType: 'ASC' } },
                        { label: 'Priority (High to Low)', value: { sortBy: SortJobBy.SystemPriority, sortType: 'ASC' } }
                    ]
                },
                {
                    label: 'Sort Order',
                    items: [
                        { label: 'Farthest to Closest', value: { sortBy: SortJobBy.CompletedDate, sortType: 'DESC' } }
                    ]
                }
            ];
        } else if (sortBy === SortJobBy.CompletedDate && sortType === 'DESC') {
            return [
                {
                    label: 'Sort By',
                    items: [
                        { label: 'Created Date (Newest to Oldest)', value: { sortBy: SortJobBy.CreatedDate, sortType: 'ASC' } },
                        { label: 'Completed Date (Farthest to Closest)', value: { sortBy: SortJobBy.CompletedDate, sortType: 'DESC' } },
                        { label: 'Due Date (Closest to Farthest)', value: { sortBy: SortJobBy.DueDate, sortType: 'ASC' } },
                        { label: 'Priority (High to Low)', value: { sortBy: SortJobBy.SystemPriority, sortType: 'ASC' } }
                    ]
                },
                {
                    label: 'Sort Order',
                    items: [
                        { label: 'Closest to Farthest', value: { sortBy: SortJobBy.CompletedDate, sortType: 'ASC' } }
                    ]
                }
            ];
        } else if (sortBy === SortJobBy.SystemPriority && sortType === 'ASC') {
            return [
                {
                    label: 'Sort By',
                    items: [
                        { label: 'Created Date (Newest to Oldest)', value: { sortBy: SortJobBy.CreatedDate, sortType: 'DESC' } },
                        { label: 'Due Date (Closest to Farthest)', value: { sortBy: SortJobBy.DueDate, sortType: 'ASC' } },
                        { label: 'Priority (High to Low)', value: { sortBy: SortJobBy.SystemPriority, sortType: 'ASC' } }
                    ]
                },
                {
                    label: 'Sort Order',
                    items: [
                        { label: 'Low to High', value: { sortBy: SortJobBy.SystemPriority, sortType: 'DESC' } }
                    ]
                }
            ];
        } else if (sortBy === SortJobBy.SystemPriority && sortType === 'DESC') {
            return [
                {
                    label: 'Sort By',
                    items: [
                        { label: 'Created Date (Newest to Oldest)', value: { sortBy: SortJobBy.CreatedDate, sortType: 'DESC' } },
                        { label: 'Due Date (Closest to Farthest)', value: { sortBy: SortJobBy.DueDate, sortType: 'ASC' } },
                        { label: 'Priority (Low to High)', value: { sortBy: SortJobBy.SystemPriority, sortType: 'DESC' } }
                    ]
                },
                {
                    label: 'Sort Order',
                    items: [
                        { label: 'High to Low', value: { sortBy: SortJobBy.SystemPriority, sortType: 'ASC' } }
                    ]
                }
            ];
        }
    }

    public static clientOperationRefined(filter: ClientOperationFilter): boolean {

        const refined = !!filter?.text
            || !!filter?.jobTypes?.length
            || !!filter?.priorities?.length
            || !!filter?.statuses?.length

        return refined;

    }


    public static contractorOperationRefined(filter: ContractorOperationFilter): boolean {

        const refined = !!filter?.text
            || !!filter?.jobTypes?.length
            || !!filter?.priorities?.length
            || !!filter?.statuses?.length
            || !!filter?.contractorResources?.length

        return refined;

    }
}